import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SharedService } from './shared.service';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HandleHttpError } from './error.handler';
import { ApplicationPayment, Voucher, PaymentUpdateModel, CohortPaymentParameter } from '../../application/models/application-payment';


@Injectable()
export class PublicPaymentService {

  baseURL: string;

  constructor(private http: HttpClient, private sharedService: SharedService) {
    this.baseURL = this.sharedService.getBaseURL();
  }


  getPaymentUri(referenceNo: string, amount: number, paymentType: string): Observable<any>  {
    var apiUrl = this.baseURL + `/publicPayment/GetPaymentUri?referenceNo=${referenceNo}&amount=${amount}&paymentType=${paymentType}`;
   
    return this.http.get(apiUrl);
  }

  validatePaymentReferenceNo(referenceNo: string): Observable<any>  {
    var apiUrl = this.baseURL + `/publicPayment/ValidatePaymentReferenceNumber?referenceNo=${referenceNo}`;
   
    return this.http.get(apiUrl).pipe(catchError(err => HandleHttpError(err)))
  }

}
